import { getBrandAndHotelData } from '../../../helpers/handleBrandAndHotelData';
import { ClearAllIndexedDB } from '../../../indexed';
import { authMeRes } from '../../../requests/notifications';
import { clear, getItem, removeItem, setItem } from '../../../utils/localStorage';

export const AuthMeRes = async () => {
    const userData  =  getItem('user');
    const allHotels = getBrandAndHotelData();
    await authMeRes().then((res: any) => {
      // tslint:disable-next-line:no-shadowed-variable
      // tslint:disable-next-line:max-line-length
      const prevHotels = allHotels;
      // tslint:disable-next-line:max-line-length
      const newHotels = res.data && res.data.user && res.data.user.brands && res.data.user.brands.length && res.data.user.brands.flatMap(brand => brand.hotels);
      if ( newHotels && (prevHotels.length !== newHotels.length) ) {
        if (newHotels.length) {
          setItem('selectedHotel', newHotels[0].id);
          setItem('selectedClient', newHotels[0].clientId);
          setItem('allHotels', res.data.user.brands.flatMap(brand => brand.hotels));
        } else {
          removeItem('selectedHotel');
        }
        window.location.reload();
      }
      setItem('user', res.data);
      if (res.data && res.data.userProfile) {
      setItem('userProfile', res.data.userProfile);
      }
    }).catch(() => {
      if (getItem('iosApp')) {
        setItem('iosApp', true); 
        window.location.href = '/login';
      } else {
      window.location.href = '/login';
    }
      ClearAllIndexedDB();
      const isUserIgnoredPin = getItem('isUserIgnoredPin');
      const userProfile = getItem('userProfile');
      const sessionId = getItem('sessionId');
      const selectedHotelId = getItem('selectedHotel');
      const selectedClientId = getItem('selectedClient');
      clear(); 
      let userEmail: string;

      if (userData && userData.user && userData.user.userEmail) {
        userEmail = userData.user.userEmail.trim().toLowerCase();
      } else {
        userEmail = userProfile.userEmail.trim().toLowerCase();
      }

      if (userEmail) {
        localStorage.setItem('email', userEmail);
      }
      if (userData && userData.user && userData.user.userPhone) {
        localStorage.setItem('phonenumber', userData.user.userPhone);
      }
      localStorage.setItem('sessionId', sessionId);
      localStorage.setItem('selectedHotel', selectedHotelId);
      localStorage.setItem('selectedClient', selectedClientId);
      setItem('isUserIgnoredPin', isUserIgnoredPin);
  });  
  };
